export default __webpack_public_path__ + "static/media/milligram.458a15fb.svg";